function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "field",
    "type",
    "align",
    "width",
    "height",
    "empty",
    "style",
    "className"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Skeleton from '@mui/material/Skeleton';
import { unstable_composeClasses as composeClasses, unstable_capitalize as capitalize } from '@mui/utils';
import { fastMemo } from '@mui/x-internals/fastMemo';
import { createRandomNumberGenerator } from "../../utils/utils.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { getDataGridUtilityClass } from "../../constants/gridClasses.js";
import { jsx as _jsx } from "react/jsx-runtime";
var CIRCULAR_CONTENT_SIZE = '1.3em';
var CONTENT_HEIGHT = '1.2em';
var DEFAULT_CONTENT_WIDTH_RANGE = [
    40,
    80
];
var CONTENT_WIDTH_RANGE_BY_TYPE = {
    number: [
        40,
        60
    ],
    string: [
        40,
        80
    ],
    date: [
        40,
        60
    ],
    dateTime: [
        60,
        80
    ],
    singleSelect: [
        40,
        80
    ]
};
var useUtilityClasses = function(ownerState) {
    var align = ownerState.align, classes = ownerState.classes, empty = ownerState.empty;
    var slots = {
        root: [
            'cell',
            'cellSkeleton',
            "cell--text".concat(align ? capitalize(align) : 'Left'),
            empty && 'cellEmpty'
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
var randomNumberGenerator = createRandomNumberGenerator(12345);
function GridSkeletonCell(props) {
    var field = props.field, type = props.type, align = props.align, width = props.width, height = props.height, _props_empty = props.empty, empty = _props_empty === void 0 ? false : _props_empty, style = props.style, className = props.className, other = _objectWithoutPropertiesLoose(props, _excluded);
    var rootProps = useGridRootProps();
    var ownerState = {
        classes: rootProps.classes,
        align: align,
        empty: empty
    };
    var classes = useUtilityClasses(ownerState);
    // Memo prevents the non-circular skeleton widths changing to random widths on every render
    var skeletonProps = React.useMemo(function() {
        var isCircularContent = type === 'boolean' || type === 'actions';
        if (isCircularContent) {
            return {
                variant: 'circular',
                width: CIRCULAR_CONTENT_SIZE,
                height: CIRCULAR_CONTENT_SIZE
            };
        }
        var _CONTENT_WIDTH_RANGE_BY_TYPE_type;
        // The width of the skeleton is a random number between the min and max values
        // The min and max values are determined by the type of the column
        var _ref = _sliced_to_array(type ? (_CONTENT_WIDTH_RANGE_BY_TYPE_type = CONTENT_WIDTH_RANGE_BY_TYPE[type]) !== null && _CONTENT_WIDTH_RANGE_BY_TYPE_type !== void 0 ? _CONTENT_WIDTH_RANGE_BY_TYPE_type : DEFAULT_CONTENT_WIDTH_RANGE : DEFAULT_CONTENT_WIDTH_RANGE, 2), min = _ref[0], max = _ref[1];
        return {
            variant: 'text',
            width: "".concat(Math.round(randomNumberGenerator(min, max)), "%"),
            height: CONTENT_HEIGHT
        };
    }, [
        type
    ]);
    return /*#__PURE__*/ _jsx("div", _extends({
        "data-field": field,
        className: clsx(classes.root, className),
        style: _extends({
            height: height,
            maxWidth: width,
            minWidth: width
        }, style)
    }, other, {
        children: !empty && /*#__PURE__*/ _jsx(Skeleton, _extends({}, skeletonProps))
    }));
}
process.env.NODE_ENV !== "production" ? GridSkeletonCell.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    align: PropTypes.string,
    /**
   * If `true`, the cell will not display the skeleton but still reserve the cell space.
   * @default false
   */ empty: PropTypes.bool,
    field: PropTypes.string,
    height: PropTypes.oneOfType([
        PropTypes.oneOf([
            'auto'
        ]),
        PropTypes.number
    ]),
    type: PropTypes.oneOf([
        'actions',
        'boolean',
        'custom',
        'date',
        'dateTime',
        'number',
        'singleSelect',
        'string'
    ]),
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
} : void 0;
var Memoized = fastMemo(GridSkeletonCell);
export { Memoized as GridSkeletonCell };
